import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Default the app to light mode so the dashboard background stays bright by default.
  const [theme, setTheme] = useState('light');

  // On mount, normalize any previously stored theme to light (we don't expose a user toggle yet).
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme !== 'light') {
      localStorage.setItem('theme', 'light');
    }
    setTheme('light');
  }, []);

  useEffect(() => {
    // Apply theme class to document
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    
    // Save to localStorage
    localStorage.setItem('theme', theme);
  }, [theme]);

  const setThemePreference = (value) => {
    setTheme(value === 'dark' ? 'dark' : 'light');
  };

  const toggleTheme = () => {
    setThemePreference(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme: setThemePreference, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};
